var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraphicClockSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 95,
  height: 101
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f1f3f9",
  stroke: "#aab2c5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M58.913 15.9H30.687v-5.569A9.46 9.46 0 0 1 40.162.998h9.283a9.45 9.45 0 0 1 9.467 9.333ZM78.44 32.474l-7.246-7.8 6.971-6.4a2.275 2.275 0 0 1 3.339.134l4.041 4.324a2.27 2.27 0 0 1-.142 3.339ZM10.046 32.474l7.247-7.8-6.963-6.4a2.285 2.285 0 0 0-3.348.134L2.95 22.732a2.27 2.27 0 0 0 .134 3.339Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f1f3f9",
  stroke: "#aab2c5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M44.32 97.8A42.9 42.9 0 1 0 1 54.9a43.11 43.11 0 0 0 43.32 42.9"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M44.312 91.398a36.5 36.5 0 1 0-36.767-36.5 36.635 36.635 0 0 0 36.767 36.5Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6dce8",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M81.087 54.898a9 9 0 0 1-.142 1.953 36.772 36.772 0 0 0-73.4-.142c0-.693-.142-1.252-.142-1.945a36.843 36.843 0 0 1 73.683.134Z",
  opacity: 0.3
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#aab2c5",
  d: "M41.674 55.875a2.64 2.64 0 0 1 2.646-2.646 2.42 2.42 0 0 1 2.5 2.513 2.65 2.65 0 0 1-2.646 2.646 2.413 2.413 0 0 1-2.5-2.513"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6dce8",
  d: "M45.431 80.394H43.06a.8.8 0 0 0-.835.835v5.844a.805.805 0 0 0 .835.835h2.371a.8.8 0 0 0 .835-.835v-5.844c-.142-.417-.421-.835-.835-.835M45.431 21.195H43.06a.8.8 0 0 0-.835.835v5.852a.805.805 0 0 0 .835.835h2.371a.8.8 0 0 0 .835-.835V22.03c-.142-.418-.421-.835-.835-.835M17.989 52.26h-5.844a.8.8 0 0 0-.835.835v2.363a.8.8 0 0 0 .835.834h5.844a.8.8 0 0 0 .835-.834v-2.363a.8.8 0 0 0-.835-.835M77.321 55.314v-2.371a.8.8 0 0 0-.835-.835h-5.852a.805.805 0 0 0-.835.835v2.371a.8.8 0 0 0 .835.835h5.852c.418-.141.835-.418.835-.835",
  opacity: 0.75
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f2f5fc",
  d: "M44.192 61.265a5.426 5.426 0 1 0-5.429-5.425 5.427 5.427 0 0 0 5.429 5.425"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#dae1ed",
  d: "M67.236 34.357a1.684 1.684 0 0 0-2.216 0L45.852 54.51h-.22a2.506 2.506 0 0 0-2.548 2.547v.332l-3.1 3.211a1.68 1.68 0 0 0 0 2.215 1.42 1.42 0 0 0 1.108.443 1.29 1.29 0 0 0 1.108-.443l3.1-3.211h.222a2.507 2.507 0 0 0 2.548-2.547v-.332l19.166-20.043a1.6 1.6 0 0 0 0-2.325",
  opacity: 0.3
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#aab2c5",
  d: "M65.795 33.139a1.684 1.684 0 0 0-2.216 0L44.413 53.293h-.222a2.506 2.506 0 0 0-2.548 2.547v.332l-3.1 3.211a1.68 1.68 0 0 0 0 2.215 1.42 1.42 0 0 0 1.108.443 1.29 1.29 0 0 0 1.108-.443l3.1-3.211h.221a2.506 2.506 0 0 0 2.548-2.547v-.332l19.167-20.043a1.7 1.7 0 0 0 0-2.326"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.192 56.285a.443.443 0 1 0-.441-.448.443.443 0 0 0 .441.448"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(58.1 63.613)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.5,
  cy: 17,
  fill: "#fff",
  rx: 16.5,
  ry: 17,
  transform: "translate(1.9 2.387)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#35df90",
  d: "M-.6 18.512A18.5 18.5 0 0 1 17.9.012a18.5 18.5 0 0 1 18.5 18.5 18.5 18.5 0 0 1-18.5 18.5 18.5 18.5 0 0 1-18.5-18.5m26.868-3.194a2.03 2.03 0 0 0 0-2.862 2.03 2.03 0 0 0-2.862 0l-7.819 7.819-3.194-3.194a2.03 2.03 0 0 0-2.862 0 2.03 2.03 0 0 0 0 2.862l4.625 4.625a2.03 2.03 0 0 0 2.862 0Z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#31cc84",
  strokeWidth: 2,
  transform: "translate(57 63)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 18
}))));
export default SvgGraphicClockSuccess;